module.exports = __webpack_public_path__ + "static/media/Blue-tick.f5029b31.svg";